import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import SocialMediaAccount from './social-media-account-model'
import {
  CreateSocialMediaAccountAsync,
  DeleteSocialMediaAccountAsync,
  LoadSocialMediaAccountsAsync,
} from './socialMediaAccount-thunk'
const initialState: socialMediaAccountSliceState = {
  socialMediaAccount: [],
  selected_socialMediaAccount: '',
  is_loading_socialMediaAccount: false,
  is_creating_socialMediaAccount: false,
  is_deleting_socialMediaAccount: false,
}
export interface socialMediaAccountSliceState {
  socialMediaAccount: SocialMediaAccount[]
  selected_socialMediaAccount?: string
  is_loading_socialMediaAccount: boolean
  is_creating_socialMediaAccount: boolean
  is_deleting_socialMediaAccount: boolean
}
export const socialMediaAccountSlice = createSlice({
  name: 'socialMediaAccount',
  initialState,
  reducers: {
    setSelectedsocialMediaAccount: (state, action) => {
      state.selected_socialMediaAccount = action.payload
    },
    clearStatesocialMediaAccount: (state) => {
      state.socialMediaAccount = []
      state.is_loading_socialMediaAccount = false
      state.is_creating_socialMediaAccount = false
      state.is_deleting_socialMediaAccount = false
    },
    mergesocialMediaAccount: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_socialMediaAccount = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.socialMediaAccount = merge(
            state.socialMediaAccount,
            payload,
          ) as any
        }
      }
    },

    add_socialMediaAccount: (state, action) => {
      if (action.payload) {
        state.socialMediaAccount = [...state.socialMediaAccount, action.payload]
      }
    },
    set_socialMediaAccount: (state, action) => {
      let { key, value, id } = action.payload
      state.socialMediaAccount = state.socialMediaAccount.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSocialMediaAccountsAsync.pending, (state) => {
      state.is_loading_socialMediaAccount = true
    })
    builder.addCase(LoadSocialMediaAccountsAsync.fulfilled, (state, action) => {
      state.is_loading_socialMediaAccount = false
      if (action.payload) {
        state.socialMediaAccount = action.payload
      }
    })
    builder.addCase(LoadSocialMediaAccountsAsync.rejected, (state) => {
      state.is_loading_socialMediaAccount = false
    })
    builder.addCase(CreateSocialMediaAccountAsync.pending, (state) => {
      state.is_creating_socialMediaAccount = true
    })
    builder.addCase(CreateSocialMediaAccountAsync.fulfilled, (state) => {
      state.is_creating_socialMediaAccount = false
    })
    builder.addCase(CreateSocialMediaAccountAsync.rejected, (state) => {
      state.is_creating_socialMediaAccount = false
    })
    builder.addCase(DeleteSocialMediaAccountAsync.pending, (state) => {
      state.is_deleting_socialMediaAccount = true
    })
    builder.addCase(
      DeleteSocialMediaAccountAsync.fulfilled,
      (state, action) => {
        state.is_deleting_socialMediaAccount = false
        if (state.socialMediaAccount) {
          state.socialMediaAccount = state.socialMediaAccount.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteSocialMediaAccountAsync.rejected, (state) => {
      state.is_deleting_socialMediaAccount = false
    })
  },
})

export const {
  clearStatesocialMediaAccount,
  setSelectedsocialMediaAccount,
  set_socialMediaAccount,
  mergesocialMediaAccount,
  add_socialMediaAccount,
} = socialMediaAccountSlice.actions

export const get_socialMediaAccount =
  (id?: string) =>
  (state: {
    socialMediaAccount: {
      socialMediaAccount: SocialMediaAccount[]
    }
  }): SocialMediaAccount | null => {
    let temp = state?.socialMediaAccount?.socialMediaAccount?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.socialMediaAccount?.socialMediaAccount[0] || null
  }
export const get_selected_socialMediaAccount = (state: {
  socialMediaAccount: socialMediaAccountSliceState
}): SocialMediaAccount | null => {
  let id = state?.socialMediaAccount?.selected_socialMediaAccount
  let temp = state?.socialMediaAccount?.socialMediaAccount?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_socialMediaAccount = (state: {
  socialMediaAccount: {
    socialMediaAccount: SocialMediaAccount[]
  }
}): SocialMediaAccount[] => {
  let temp = state?.socialMediaAccount?.socialMediaAccount
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_socialMediaAccount_busy = (state: {
  socialMediaAccount: socialMediaAccountSliceState
}) => {
  return (
    state?.socialMediaAccount.is_deleting_socialMediaAccount ||
    state?.socialMediaAccount.is_loading_socialMediaAccount ||
    state?.socialMediaAccount.is_creating_socialMediaAccount
  )
}
export const is_deleting_socialMediaAccount_busy = (state: {
  socialMediaAccount: socialMediaAccountSliceState
}) => {
  return state?.socialMediaAccount.is_deleting_socialMediaAccount
}
export const is_loading_socialMediaAccount_busy = (state: {
  socialMediaAccount: socialMediaAccountSliceState
}) => {
  return state?.socialMediaAccount.is_loading_socialMediaAccount
}
export const is_creating_socialMediaAccount_busy = (state: {
  socialMediaAccount: socialMediaAccountSliceState
}) => {
  return state?.socialMediaAccount.is_creating_socialMediaAccount
}

export default socialMediaAccountSlice.reducer
